import http, { createApi } from '@core/fetch'

export default {
  OrderInfo: params =>
    http(
      '/p/wedding/index.php/admin/APIHotelOrderSub/detail?' + (params || '')
    ),
  OrderHistory: params =>
    http(
      '/p/wedding/index.php/Admin/APIHotelOrderSub/followup?' + (params || '')
    ),
  comeMerchant: createApi.post(
    '/p/wedding/index.php/Admin/APIHotelOrderSub/come_merchant'
  ),
  followUp: createApi.post(
    '/p/wedding/index.php/Admin/APIHotelOrderSub/followup'
  ),
  followFail: createApi.post(
    '/p/wedding/index.php/Admin/APIHotelOrderSub/follow_fail'
  ),
  PostOrderFB: createApi.post(
    '/p/wedding/index.php/Admin/APIHotelOrderFeedBack/edit'
  ),
  GetOrderFB: params =>
    http(
      '/p/wedding/index.php/Admin/APIHotelOrderFeedBack/edit?' + (params || '')
    ),
  GetAssigns: params =>
    http(
      '/p/wedding/index.php/Admin/APIHotelOrderSub/assigns?' + (params || '')
    ),
  GetHall: params =>
    http(
      '/p/wedding/index.php/admin/APIMerchantCalenderItem/hotel_halls?' +
        (params || '')
    ),
  OrderSub: params =>
    http(
      '/p/wedding/index.php/admin/APIHotelOrderSub/index?' + (params || ''),
      {
        body: { hotel: 1 }
      }
    ),
  OrderHiy: params =>
    http(
      '/p/wedding/index.php/Admin/APIHotelOrderSub/followup?' + (params || '')
    ),
  OrderFB_list: params =>
    http(
      '/p/wedding/index.php/Admin/APIHotelOrderFeedBack/list?' + (params || '')
    ),
  walletList: params =>
    http(
      '/p/wedding/index.php/Admin/APIHotelOrderWallet/wallet_list?' +
        (params || '')
    ),
  refund: createApi.post(
    '/p/wedding/index.php/Admin/APIHotelOrderFeedBack/refund'
  )
}
